import store from '@/store';

/**
 *
 * @param basePath
 * @param parent
 */
export function generateTariffSettingsRoutes(basePath, parent = null) {
  const guard = (to, from, next) => {
    if (store.getters.USER.organizationId && store.getters.USER.organizationType === 'head') {
      next();
    } else {
      next({ name: 'prime' });
    }
  };

  return [
    {
      path: `${basePath}/tariff-settings`,
      name: `${parent ? parent + '.' : ''}tariff-settings`,
      meta: {
        layout: 'emptyLayout',
        requiresAuth: true,
        title: 'Тарифи',
        breadcrumb: 'Тарифи',
        parent: parent,
        hideHeader: true,
      },
      beforeEnter: guard,
      component: () => import('../pages/organizations/tariffs.vue'),
    },
    // {
    //     path: `${basePath}/managers/create`,
    //     name: `${parent ? parent + '.' : ''}managers.create`,
    //     meta: {
    //         layout: 'profileLayout',
    //         requiresAuth: true,
    //         title: 'Менеджери',
    //         breadcrumb: 'Менеджери',
    //         // title: 'Новий менеджер',
    //         // breadcrumb: 'Новий менеджер',
    //         // parent: `${parent ? parent + '.' : ''}managers`,
    //         parent: parent,
    //         hideHeader: true,
    //     },
    //     beforeEnter: guard,
    //     component: () => import('@/views/organizations/managers/CreateEdit.vue'),
    // },
    // {
    //     path: `${basePath}/managers/:managerId`,
    //     name: `${parent ? parent + '.' : ''}managers.edit`,
    //     meta: {
    //         layout: 'profileLayout',
    //         requiresAuth: true,
    //         title: 'Менеджери',
    //         breadcrumb: 'Менеджери',
    //         // title: 'Новий менеджер',
    //         // breadcrumb: 'Новий менеджер',
    //         // parent: `${parent ? parent + '.' : ''}managers`,
    //         parent: parent,
    //         hideHeader: true,
    //     },
    //     beforeEnter: guard,
    //     component: () => import('@/views/organizations/managers/CreateEdit.vue'),
    // },
  ];
}

/**
 *
 * @param basePath
 * @param parent
 */
export function generateManagerRoutes(basePath, parent = null) {
  const guard = (to, from, next) => {
    if (store.getters.USER.organizationId && store.getters.USER.organizationType === 'head') {
      next();
    } else {
      next({ name: 'prime' });
    }
  };

  return [
    {
      path: `${basePath}/managers`,
      name: `${parent ? parent + '.' : ''}managers`,
      meta: {
        layout: 'emptyLayout',
        requiresAuth: true,
        title: 'Менеджери',
        breadcrumb: 'Менеджери',
        parent: parent,
        hideHeader: true,
      },
      beforeEnter: guard,
      component: () => import('../pages/organizations/managers/managers.vue'),
    },
    {
      path: `${basePath}/managers/create`,
      name: `${parent ? parent + '.' : ''}managers.create`,
      meta: {
        layout: 'emptyLayout',
        requiresAuth: true,
        title: 'Менеджери',
        breadcrumb: 'Менеджери',
        // title: 'Новий менеджер',
        // breadcrumb: 'Новий менеджер',
        // parent: `${parent ? parent + '.' : ''}managers`,
        parent: parent,
        hideHeader: true,
      },
      beforeEnter: guard,
      component: () => import('../pages/organizations/managers/createEdit.vue'),
    },
    {
      path: `${basePath}/managers/:managerId`,
      name: `${parent ? parent + '.' : ''}managers.edit`,
      meta: {
        layout: 'emptyLayout',
        requiresAuth: true,
        title: 'Менеджери',
        breadcrumb: 'Менеджери',
        // title: 'Новий менеджер',
        // breadcrumb: 'Новий менеджер',
        // parent: `${parent ? parent + '.' : ''}managers`,
        parent: parent,
        hideHeader: true,
      },
      beforeEnter: guard,
      component: () => import('../pages/organizations/managers/createEdit.vue'),
    },
  ];
}

const organizations = [
  {
    path: '/organizations',
    name: 'organizations',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Головні установи',
      breadcrumb: 'Установи',
      hideHeader: true,
    },
    beforeEnter: (to, from, next) => {
      if (store.getters.USER.organizationId && store.getters.USER.organizationType === 'head') {
        next();
      } else {
        next({ name: 'prime' });
      }
    },
    component: () => import('../pages/organizations/index.vue')
  },
  {
    path: '/organizations/:organizationId',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Менеджери',
      breadcrumb: 'Менеджери',
      parent: 'organizations',
      hideHeader: true,
    },
    component: () => import('../pages/organizations/managers.vue'),
    children: [
      ...generateManagerRoutes('/organizations/:organizationId', 'organizations'),
      ...generateTariffSettingsRoutes('/organizations/:organizationId', 'organizations')
    ],
  },
  {
    path: '/organizations/:organizationId/regions',
    name: 'regions',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Дирекції',
      breadcrumb: 'Дирекції',
      parent: 'organizations',
      hideHeader: true,
    },
    beforeEnter: (to, from, next) => {
      if (store.getters.USER.organizationId && store.getters.USER.organizationType === 'head') {
        next();
      } else {
        next({ name: 'prime' });
      }
    },
    component: () => import('../pages/organizations/regions.vue')
  },
  {
    path: '/organizations/:organizationId/regions/:regionId/branches',
    name: 'branches',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Відділення',
      breadcrumb: 'Відділення',
      parent: 'regions',
      hideHeader: true,
    },
    beforeEnter: (to, from, next) => {
      if (store.getters.USER.organizationId && store.getters.USER.organizationType === 'head') {
        next();
      } else {
        next({ name: 'prime' });
      }
    },
    component: () => import('../pages/organizations/branches.vue')
  },
  {
    path: '/organizations/:organizationId/regions/:regionId',
    component: () => import('../views/organizations/Show.vue'),
    children: [
      ...generateManagerRoutes('/organizations/:organizationId/regions/:regionId', 'regions'),
      ...generateTariffSettingsRoutes('/organizations/:organizationId/regions/:regionId', 'regions')
    ],
  },
  {
    path: '/organizations/:organizationId/regions/:regionId/branches/:branchId',
    component: () => import('../views/organizations/Show.vue'),
    children: [
      ...generateManagerRoutes('/organizations/:organizationId/regions/:regionId/branches/:branchId', 'branches'),
      ...generateTariffSettingsRoutes('/organizations/:organizationId/regions/:regionId/branches/:branchId', 'branches')
    ],
  },
];

export default organizations;
